import { Typography } from '@mui/material'
import React from 'react'
import HeaderGestorConfigs from './headerGestorConfigs'
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'


interface GraficoPorEmolumentosProps {
    chartData?: any[];
    chartDataProvincia?: any[];
    ano?: number;
    provinciaSelecionada: string | null;
    setProvinciaSelecionada: (value: string | null) => void
}

const GraficoEstabelecimento: React.FC<GraficoPorEmolumentosProps> = ({ chartData, ano, chartDataProvincia, setProvinciaSelecionada, provinciaSelecionada }) => {
    if (!chartData || chartData.length === 0 || !chartDataProvincia) {
        return <Typography>Dados insuficientes para exibir os gráficos.</Typography>;
    }
    const colors = ["#99288b", "#82ca9d", "#ffc658",];

    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', justifyContent: 'flex-start', padding: '2px', margin: '4px 0' }}>
            <div style={{ flex: 1, width: '100%', minWidth: '300px' }}>
                <div style={{ background: '#FFF', padding: '10px' }}>
                    <HeaderGestorConfigs title={`Estabelecimentos em ${ano}`} />
                    <ResponsiveContainer width="100%" height={350}>
                        <BarChart
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 5, bottom: 20 }}
                        >
                            <XAxis
                                dataKey="mes"
                                tick={{ fontSize: window.innerWidth < 768 ? 10 : 12 }}
                            />

                            <YAxis
                                tick={{ fontSize: window.innerWidth < 768 ? 10 : 12 }}
                                width={70}
                            />

                            <Tooltip
                                cursor={{ fill: "rgba(0,0,0,0.05)" }}
                                contentStyle={{
                                    fontSize: window.innerWidth < 768 ? "12px" : "14px",
                                    borderRadius: 5
                                }}
                            />

                            <Bar
                                dataKey="total"
                                name="Total"
                                isAnimationActive
                                animationDuration={800}
                                animationEasing="ease-out"
                            >
                                {chartData.map((_, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={colors[index % colors.length]}
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
            <div style={{ flex: 1, width: '100%', minWidth: '300px' }}>
                <div style={{ background: '#FFF', padding: '10px' }}>
                    <HeaderGestorConfigs title={`Estabelecimentos por Províncias em ${ano}`} />
                    <ResponsiveContainer width="100%" height={350}>
                        <BarChart
                            data={chartDataProvincia}
                            margin={{ top: 20, right: 30, left: 5, bottom: 20 }}
                        >
                            <XAxis
                                dataKey="provincia"
                                tick={{ fontSize: window.innerWidth < 768 ? 10 : 12 }}
                            />

                            <YAxis
                                tick={{ fontSize: window.innerWidth < 768 ? 10 : 12 }}
                                width={70}
                            />


                            <Tooltip
                                formatter={(value: number, _name: string, props: any) =>
                                    `${value} (${props.payload.percentagem}%)`
                                }
                            />


                            <Bar
                                dataKey="total"
                                name="Total"
                                isAnimationActive
                                animationDuration={800}
                                animationEasing="ease-out"
                                onClick={(data) => {
                                    setProvinciaSelecionada(data.provincia);
                                }}
                            >
                                {chartDataProvincia.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={
                                            provinciaSelecionada === entry.provincia
                                                ? "#2563eb"
                                                : colors[index % colors.length]
                                        }
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    )
}

export default GraficoEstabelecimento
